/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyListContainer3_viewer = {
    readonly id: string;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListCommentContainer_viewer" | "ReplyListContainerLast_viewer">;
    readonly " $refType": "ReplyListContainer3_viewer";
};
export type ReplyListContainer3_viewer$data = ReplyListContainer3_viewer;
export type ReplyListContainer3_viewer$key = {
    readonly " $data"?: ReplyListContainer3_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainer3_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListContainer3_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListCommentContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListContainerLast_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '714d00a83336ec5ba26d99c5f78c0b27';
export default node;
